// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1IQJv","savePackageButton":"ClientWallet_savePackageButton__2NAeH"};